import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ServiceItem from '../service-item';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonCircleList from '../../../common-components/common-circle-list';

const processList = {
    colorNumber: '#3a74b7',
    list: [
        'оставить заявку на&nbsp;консультацию специалиста,',
        'получить госуслуги (после регистрации),',
        'задать вопросы через онлайн-форму,',
        'подобрать маркетплейс для своих товаров,',
        'подписаться на&nbsp;новости,',
        'оставить отзыв,',
        'и&nbsp;многое другое.',
    ],
};
const serviceItem = {
    img: '/images/pic/dev-rec/service-1.png',
    mainTitle: 'Сайт',
    mainTitleColor: '#3a74b7',
    mainTitleDesc: 'Для сайта мы&nbsp;разработали 2&nbsp;новых раздела.',
    title: 'Электронная торговля',
    link: 'https://www.exportcenter.ru/e-commerce/',
    text: [
        'Здесь любой экспортер может получить рекомендацию по&nbsp;выбору маркетплейса для экспорта своего ' +
            'продукта, настроив фильтры по&nbsp;стране поставки и&nbsp;отрасли. Кроме того, зарегистрированные ' +
            'пользователи могут',
    ],
    isReversed: true,
    list: {
        colorNumber: '#3a74b7',
        list: [
            'получить консультацию по&nbsp;онлайн-торговле,',
            'выбору электронной торговой площадки,',
            'выйти на&nbsp;национальный маркет Tmall Food &amp;&nbsp;Fresh.',
        ],
    },
};

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper isMargin={false} caseName="dev-rec-process">
                <div className="dev-rec-process__content">
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="dev-rec-process__title">
                            <CommonTitle>Процесс</CommonTitle>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="dev-rec-process__item">
                            <CommonSmallTitle className="dev-rec-process__item-title">
                                Техподдержка
                            </CommonSmallTitle>
                            <br />
                            <div className="dev-rec-process__item-subtitle">
                                Сайт и&nbsp;внутренний портал находятся на&nbsp;разных доменах,
                                но&nbsp;оба имеют сложную архитектуру и&nbsp;структуру.
                            </div>
                            <CommonSmallText className="common__small-text--full">
                                Сайт состоит из&nbsp;десятков разделов. Сотрудники регулярно
                                обновляют контент: афишу мероприятий, новости, информацию
                                о&nbsp;нацпроектах, премиях, форумах, изменениях
                                в&nbsp;законодательстве, загружают свежие номера корпоративных
                                изданий и&nbsp;многое другое.
                            </CommonSmallText>
                            <br />
                            <br />
                            <div className="dev-rec-process__item-subtitle">
                                На&nbsp;сайте компании-экспортеры могут:
                            </div>
                            <CommonCircleList CommonCircleList={processList} />
                            <br />
                            <CommonSmallText className="common__small-text--full">
                                На&nbsp;внутреннем портале сотрудники работают с&nbsp;заявками
                                экспортеров, документами, могут участвовать во&nbsp;внутренних
                                голосованиях, благотворительных акциях, отслеживать выполнение
                                рабочих задач и&nbsp;многое другое.
                            </CommonSmallText>
                            <br />
                            <CommonSmallText className="common__small-text--full">
                                От&nbsp;отказоустойчивости и&nbsp;скорости работы сайта
                                и&nbsp;портала напрямую зависит эффективность работы центра
                                и&nbsp;качество оказываемых им&nbsp;услуг. Именно поэтому Группе РЭЦ
                                было важно найти подрядчика, работающего по&nbsp;SLA.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="dev-rec-process__item">
                            <CommonSmallTitle className="dev-rec-process__item-title">
                                Как мы&nbsp;взаимодействуем?
                            </CommonSmallTitle>
                            <br />
                            <CommonSmallText className="common__small-text--full">
                                Заказчик ставит задачи команде разработчиков через Trello, срочные
                                вопросы решаются в&nbsp;Telegram. Одновременно в&nbsp;работе
                                находится не&nbsp;менее 12&nbsp;задач. По&nbsp;каждой карточке
                                в&nbsp;Trello специалисты получают от&nbsp;заказчика по&nbsp;4-8
                                запросов в&nbsp;день через Telegram. Время реагирования
                                на&nbsp;запрос не&nbsp;превышает 15&nbsp;минут.
                            </CommonSmallText>
                            <br />
                            <CommonSmallText className="common__small-text--full">
                                Кроме текущих задач, регулярно возникает потребность
                                в&nbsp;доработках,оптимизации и&nbsp;модернизации сайта
                                и&nbsp;портала. Этими вопросами также занимается наша команда.
                            </CommonSmallText>
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
            <FullWrapper isMargin={false} caseName="dev-rec-process">
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="dev-rec-process__item dev-rec-process__item--without-margin">
                        <CommonSmallTitle className="dev-rec-process__item-title">
                            Модернизация
                        </CommonSmallTitle>
                        <br />
                        <ServiceItem serviceItem={serviceItem} />
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
